export default function UnitedStatesFlag() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="2" fill="#B22234" />
            <rect y="1.54" width="20" height="1.54" fill="white" />
            <rect y="4.62" width="20" height="1.54" fill="white" />
            <rect y="7.69" width="20" height="1.54" fill="white" />
            <rect y="10.77" width="20" height="1.54" fill="white" />
            <rect y="13.85" width="20" height="1.54" fill="white" />
            <rect y="16.92" width="20" height="1.54" fill="white" />
            <rect width="8" height="10.77" fill="#3C3B6E" />
            <circle cx="1.6" cy="1.8" r="0.45" fill="white" />
            <circle cx="3.2" cy="1.8" r="0.45" fill="white" />
            <circle cx="4.8" cy="1.8" r="0.45" fill="white" />
            <circle cx="6.4" cy="1.8" r="0.45" fill="white" />
            <circle cx="2.4" cy="3.2" r="0.45" fill="white" />
            <circle cx="4" cy="3.2" r="0.45" fill="white" />
            <circle cx="5.6" cy="3.2" r="0.45" fill="white" />
            <circle cx="1.6" cy="4.6" r="0.45" fill="white" />
            <circle cx="3.2" cy="4.6" r="0.45" fill="white" />
            <circle cx="4.8" cy="4.6" r="0.45" fill="white" />
            <circle cx="6.4" cy="4.6" r="0.45" fill="white" />
            <circle cx="2.4" cy="6" r="0.45" fill="white" />
            <circle cx="4" cy="6" r="0.45" fill="white" />
            <circle cx="5.6" cy="6" r="0.45" fill="white" />
            <circle cx="1.6" cy="7.4" r="0.45" fill="white" />
            <circle cx="3.2" cy="7.4" r="0.45" fill="white" />
            <circle cx="4.8" cy="7.4" r="0.45" fill="white" />
            <circle cx="6.4" cy="7.4" r="0.45" fill="white" />
            <circle cx="2.4" cy="8.8" r="0.45" fill="white" />
            <circle cx="4" cy="8.8" r="0.45" fill="white" />
            <circle cx="5.6" cy="8.8" r="0.45" fill="white" />
        </svg>
    );
}
